module.exports = __webpack_public_path__ + "static/forminspector-c3a87718955d63bdade6852031c79e8c.png";